const COURSES_PER_PAGE = 48;

/**
 * Update the Query Params to filtering search based on queries
 *
 * @param {Object} params
 */
function setQueryParams(params) {
  const url = new URL(window.location.href);
  Object.entries(params).map(function ([key, value]) {
    if (!!value) {
      url.searchParams.set(key, value);
    }

    if (!value && url.searchParams.has(key)) {
      url.searchParams.delete(key);
    }
  });
  window.history.pushState({}, '', url);
}

/**
 * Naive Search
 *
 * Using this simple function for searching in titles
 * If we need more complex search, Use the KPM Algorithm or something better
 *
 * @param {string} text
 * @param {string} word
 * @returns {int}
 */
function naiveSearch(text, word) {
  let count = 0;
  for (let i = 0; i < text.length; i++) {
    for (let j = 0; j < word.length; j++) {
      const currentWord = word[j] || '';
      const nextWord = text[i + j] || '';
      if (currentWord.toLowerCase() !== nextWord.toLowerCase()) break;
      if (j === word.length - 1) count++;
    }
  }
  return count > 0;
}

function isValidParam(param) {
  if (!param) return false;
  if (param === 'all') return false;

  return true;
}

/**
 * Apply filter to courses list and update DOM Elements based on results
 *
 * @param {string | null} category
 * @param {string | null} location
 * @param {string | null} search
 * @param {int | null} page
 */
function filterCourses(category, location, search, page = 1) {
  const all = window.ALL_COURSES_LIST;

  const filtered = all.filter((course) => {
    const matchCategory = isValidParam(category)
      ? course.categories.includes(category)
      : true;
    const matchLocation = isValidParam(location)
      ? course.locations.includes(location)
      : true;
    const matchTitle = search ? naiveSearch(course.title, search) : true;
    const matchAltTitle = search ? naiveSearch(course.alt_title, search) : true;

    return matchCategory && matchLocation && (matchTitle || matchAltTitle);
  });

  all.forEach((course) => {
    const $courseElement = document.querySelector(
      `.all-courses-list [data-course-id="${course.id}"]`
    );
    if ($courseElement) {
      $courseElement.style.display = 'none';
    }
  });

  if (filtered.length === 0) {
    const $emptyState = document.querySelector('div.courses-empty-state');
    $emptyState.style.display = 'block';
  } else {
    const $emptyState = document.querySelector('div.courses-empty-state');
    $emptyState.style.display = 'none';
  }

  if (filtered.slice(0, page * COURSES_PER_PAGE).length >= filtered.length) {
    const $paginator = document.querySelector('button[courses-list-paginator]');
    $paginator.style.display = 'none';
  }

  filtered.slice(0, page * COURSES_PER_PAGE).forEach((course) => {
    const $courseElement = document.querySelector(
      `.all-courses-list [data-course-id="${course.id}"]`
    );
    if ($courseElement) {
      $courseElement.style.display = 'flex';
    }
  });
}

function applyFilters(updateField = false) {
  const url = new URL(window.location.href);
  const params = url.searchParams;

  const category = params.get('category');
  const location = params.get('location');
  const search = params.get('search');
  const page = params.get('page');

  if (updateField) {
    const $fieldSearch = document.querySelector(
      'input[courses-list-filter-field][name="search"]'
    );

    if (category) {
      const $fieldCategory = document.querySelector(
        'input[type="radio"][name="category"][id=category-' + category + ']'
      );
      const $categoryLabel = document.querySelector(
        '#category-dropdown .selected-value'
      );
      $categoryLabel.textContent = (
        window.ALL_COURSE_CATEGORIES[category] ||
        window.ALL_COURSE_CATEGORIES['all'] ||
        'All'
      ).replace('&amp;', '&');
      if ($fieldCategory) {
        $fieldCategory.checked = true;
      }
    }
    if (location) {
      const $fieldLocation = document.querySelector(
        'input[type="radio"][name="location"][id=location-' + location + ']'
      );
      const $locationLabel = document.querySelector(
        '#location-dropdown .selected-value'
      );
      $locationLabel.textContent = (
        window.ALL_COURSE_LOCATIONS[location] ||
        window.ALL_COURSE_LOCATIONS['all'] ||
        'All'
      ).replace('&amp;', '&');
      if ($fieldLocation) {
        $fieldLocation.checked = true;
      }
    }
    if (search) {
      $fieldSearch.value = search;
    }
  }

  filterCourses(category, location, search, page ? +page : 1);
}

function closeDropdownToggler(name) {
  const $dropdownToggler = document.querySelector(
    `.filter-select#${name}-dropdown`
  );

  if ($dropdownToggler) {
    $dropdownToggler.classList.remove('active');
    const $button = $dropdownToggler.querySelector('button');

    if ($button) {
      $button.setAttribute('aria-expanded', 'false');
    }
  }
}

function setFilterListeners() {
  const $dropdownTogglers = document.querySelectorAll('.filter-select button');
  const $radioButtons = document.querySelectorAll(
    '.all-courses-list input[type="radio"]'
  );
  const $categoryLabel = document.querySelector(
    '#category-dropdown .selected-value'
  );
  const $locationLabel = document.querySelector(
    '#location-dropdown .selected-value'
  );
  const $fieldSearch = document.querySelector(
    'input[courses-list-filter-field][name="search"]'
  );
  const $paginator = document.querySelector('button[courses-list-paginator]');

  if ($dropdownTogglers) {
    document.addEventListener('click', function (event) {
      const $activeFilter = document.querySelector('.filter-select.active');

      if ($activeFilter) {
        if (!$activeFilter.contains(event.target)) {
          $activeFilter.classList.remove('active');
        }
      }
    });
    $dropdownTogglers.forEach(($toggler) => {
      $toggler.addEventListener('click', function () {
        document.querySelectorAll('.filter-select').forEach(($filter) => {
          $filter.classList.remove('active');
        });
        $toggler.parentNode.classList.toggle('active');
        $toggler.setAttribute(
          'aria-expanded',
          $toggler.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
        );
      });
    });
  }

  if ($radioButtons) {
    $radioButtons.forEach(($radio) => {
      $radio.addEventListener('change', function onClickRadio(ev) {
        closeDropdownToggler(ev.target.name);
        if (ev.target.name === 'location') {
          $locationLabel.textContent = (
            window.ALL_COURSE_LOCATIONS[this.value] || ''
          ).replace('&amp;', '&');
        }
        if (ev.target.name === 'category') {
          $categoryLabel.textContent = (
            window.ALL_COURSE_CATEGORIES[this.value] || ''
          ).replace('&amp;', '&');
        }
        setQueryParams({ [ev.target.name]: this.value, page: 1 });
        applyFilters();
      });
    });
  }

  if ($fieldSearch) {
    $fieldSearch.addEventListener('change', (event) => {
      setQueryParams({ search: event.target.value, page: 1 });
      applyFilters();
    });
  }
  if ($paginator) {
    if (window.ALL_COURSES_LIST.length > COURSES_PER_PAGE) {
      $paginator.style.display = 'block';
    }
    $paginator.addEventListener('click', () => {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      const currentPage = params.get('page');
      setQueryParams({ page: currentPage ? +currentPage + 1 : 2 });
      applyFilters();
    });
  }
}

export default function coursesFilters() {
  setFilterListeners();
  applyFilters(true);
}



// WEBPACK FOOTER //
// ./assets/js/modules/coursesFilters.js